import { DEFAULT_LOCAL_PORTS } from './localPorts';

const STAGE = process.env.STAGE;
const ENVIRONMENT_DOMAIN = process.env.ENVIRONMENT_DOMAIN ?? 'cofenster.com';

// Keep these process.env.*_PORT reads static and inside the STAGE==='local'
// branch: DefinePlugin only replaces static refs, and deployed browser bundles
// (no `process`) must never evaluate them. The ?? fallback covers non-webpack
// consumers (Cypress, Jest, ts-node).
export const CAPTURE_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.WEB_ACTOR_PORT ?? DEFAULT_LOCAL_PORTS.WEB_ACTOR_PORT}`
    : `https://capture.${ENVIRONMENT_DOMAIN}`;
export const MANAGER_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.WEB_MANAGER_PORT ?? DEFAULT_LOCAL_PORTS.WEB_MANAGER_PORT}`
    : `https://app.${ENVIRONMENT_DOMAIN}`;
export const ADMIN_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.WEB_ADMIN_PORT ?? DEFAULT_LOCAL_PORTS.WEB_ADMIN_PORT}`
    : `https://admin.${ENVIRONMENT_DOMAIN}`;
export const VIDEO_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.WEB_VIDEO_PORT ?? DEFAULT_LOCAL_PORTS.WEB_VIDEO_PORT}`
    : `https://video.${ENVIRONMENT_DOMAIN}`;
export const MAINTENANCE_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.WEB_MAINTENANCE_PORT ?? DEFAULT_LOCAL_PORTS.WEB_MAINTENANCE_PORT}`
    : `https://maintenance.${ENVIRONMENT_DOMAIN}`;
export const ASSET_URL = `https://assets.${ENVIRONMENT_DOMAIN}`;
export const ARGO_URL =
  STAGE === 'development' || STAGE === 'local'
    ? 'https://argo.dev.cofenster.com'
    : `https://argo.${ENVIRONMENT_DOMAIN}`;

export const ADMIN_API_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.ADMIN_API_PORT ?? DEFAULT_LOCAL_PORTS.ADMIN_API_PORT}/graphql`
    : `https://admin.api.${ENVIRONMENT_DOMAIN}/graphql`;
export const SERVICES_API_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.SERVICES_API_PORT ?? DEFAULT_LOCAL_PORTS.SERVICES_API_PORT}/graphql`
    : `https://services.api.${ENVIRONMENT_DOMAIN}/graphql`;
export const CUSTOMER_API_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.CUSTOMER_API_PORT ?? DEFAULT_LOCAL_PORTS.CUSTOMER_API_PORT}`
    : `https://customer.api.${ENVIRONMENT_DOMAIN}`;
export const MANAGER_API_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.MANAGER_API_PORT ?? DEFAULT_LOCAL_PORTS.MANAGER_API_PORT}/graphql`
    : `https://api.${ENVIRONMENT_DOMAIN}/graphql`;
export const CAPTURE_API_URL =
  STAGE === 'local'
    ? `http://localhost:${process.env.CAPTURE_API_PORT ?? DEFAULT_LOCAL_PORTS.CAPTURE_API_PORT}/graphql`
    : `https://capture.api.${ENVIRONMENT_DOMAIN}/graphql`;
